import { StringMap } from '@/types';

const modernPrimaryColor = '#6366F1';
const modernSecondaryColor = '#F8FAFC';
const modernTextColor = '#374151';
const activeColor = modernPrimaryColor;
const sectionActiveColor = '#CACACA';

export const boxShadowedItemResetStyles = {
  position: '',
  'box-shadow': '',
  'min-height': '',
};

export const borderedItemResetStyles = {
  position: '',
  border: '',
};

const commonButtonStyles = {
  cursor: 'pointer',
  height: '28px',
  width: '28px',
  padding: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
};

const commonButtonGroupStyles = {
  display: 'none',
  position: 'absolute',
  zIndex: '100000000',
};

const commonActionsButtonGroupStyles = {
  ...commonButtonGroupStyles,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '8px',
  borderRadius: '12px',
  background: 'rgba(255, 255, 255, 0.98)',
  backdropFilter: 'blur(12px)',
  border: '1px solid rgba(99, 102, 241, 0.15)',
  boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
};

export const addButtonGroupStyles: { [type: string]: { [position: string]: StringMap } } = {
  email: {
    top: {
      ...commonButtonGroupStyles,
      top: '0px',
      transform: 'translate(-50%, calc(-100% + 2px))',
    },
    bottom: {
      ...commonButtonGroupStyles,
      bottom: '0px',
      transform: 'translate(-50%, calc(100% - 2px))',
    },
  },
  default: {
    top: {
      ...commonButtonGroupStyles,
      top: '0px',
      transform: 'translate(-50%, -100%)',
    },
    bottom: {
      ...commonButtonGroupStyles,
      bottom: '0px',
      transform: 'translate(-50%, 100%)',
    },
  },
};

export const actionsButtonGroupStyles = {
  ...commonActionsButtonGroupStyles,
  top: '4px',
  left: '-50px',
  right: 'auto',
  bottom: 'auto',
  flexDirection: 'column',
};

export const columnActionsButtonGroupStyles = {
  ...commonActionsButtonGroupStyles,
  top: '4px',
  left: '-50px',
  right: 'auto',
  bottom: 'auto',
  flexDirection: 'column',
};

export const sectionActionsButtonGroupStyles = {
  ...commonActionsButtonGroupStyles,
  top: '4px',
  left: '4px',
  right: 'auto',
  bottom: 'auto',
  flexDirection: 'column',
};

export const primaryButtonStyles = {
  ...commonButtonStyles,
  borderRadius: '2px',
  color: '#FFFFFF',
};

export const addWidgetButtonStyle = {
  ...primaryButtonStyles,
  background: modernPrimaryColor,
  borderRadius: '8px',
  padding: '0px',
  left: '50%',
  boxShadow: '0 4px 6px rgba(99, 102, 241, 0.2)',
};

export const addSectionButtonStyle = {
  ...primaryButtonStyles,
  background: sectionActiveColor,
  padding: '0px',
  left: '50%',
};

export const secondaryButtonStyles = {
  ...commonButtonStyles,
  border: '1px solid rgba(99, 102, 241, 0.2)',
  borderRadius: '8px',
  background: 'rgba(255, 255, 255, 0.98)',
  color: modernPrimaryColor,
  boxSizing: 'border-box',
  transition: 'all 0.15s ease',
  backdropFilter: 'blur(8px)',
};

export const AIButtonStyles = {
  ...commonButtonStyles,
  border: '2px solid transparent',
  borderRadius: '8px',
  background: 'linear-gradient(#fff, #fff) padding-box,'
    + 'linear-gradient(167deg, rgba(148,200,64,1) 0%, rgba(0,153,120,1) 50%, rgba(0,114,142,1) 100%) border-box',
  color: '#009978',
  boxSizing: 'border-box',
  transition: 'all 0.15s ease',
};

export const hoverActiveItemResetStyles = {
  backgroundColor: '',
};

export const hoverResetStyles = {
  ...hoverActiveItemResetStyles,
  border: '',
  position: '',
};
